<template>
    <div class="flex items-center gap-1.5">
        <span class="text-[10px] text-gray-400 select-none whitespace-nowrap">Editor theme:</span>
        <select
            :value="editorStore.theme"
            @change="editorStore.setTheme(($event.target as HTMLSelectElement).value)"
            class="text-[10px] bg-white/10 text-gray-300 border border-white/20 rounded px-1.5 py-0.5 cursor-pointer hover:bg-white/15 outline-none focus:border-white/40">
            <optgroup label="Dark">
                <option v-for="t in editorStore.darkThemes" :key="t.id" :value="t.id">{{ t.label }}</option>
            </optgroup>
            <optgroup label="Light">
                <option v-for="t in editorStore.lightThemes" :key="t.id" :value="t.id">{{ t.label }}</option>
            </optgroup>
        </select>
    </div>
</template>

<script setup lang="ts">
import { useEditorStore } from '../stores/editorStore';

const editorStore = useEditorStore();
</script>
